/**
 * @flow
 * @relayHash 643f79e41fe60160297d8514c8b89980
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrganizationPermission = "ADD_FOLLOWERS" | "CONTRACTOR_ADD_NOTE" | "CONTRACTOR_EDIT_DETAILS" | "CONTRACTOR_GROUP_CREATE" | "CONTRACTOR_MARK_DO_NOT_HIRE" | "CONTRACTOR_MARK_PROFILE_INACTIVE" | "CONTRACTOR_UPLOAD_SHOWCASE_FILE" | "DELIVERABLE_ADD_REVIEW_COMMENT_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_ADD_REVIEW_COMMENT_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_ASSIGN_INTERNALLY_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_ASSIGN_INTERNALLY_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_CHANGE_CURRENT_REVIEW_STEP_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_CHANGE_CURRENT_REVIEW_STEP_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_CREATE" | "DELIVERABLE_DEACTIVATE" | "DELIVERABLE_DELETE" | "DELIVERABLE_DELETE_FINAL_FILE" | "DELIVERABLE_DOWNLOAD_FINAL_FILE" | "DELIVERABLE_EDIT_DETAILS_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_EDIT_DETAILS_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_EXPOSE_REFERENCE_TO_SOLICITATION" | "DELIVERABLE_INTERNAL_MARK_CLOSED_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_INTERNAL_MARK_CLOSED_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_INTERNAL_RESET_OR_CANCEL" | "DELIVERABLE_MARK_COMPLETE_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_MARK_COMPLETE_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_MARK_READY_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_MARK_READY_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_UNLOCK_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_UNLOCK_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_UPLOAD_FINAL_FILE_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_UPLOAD_FINAL_FILE_ASSIGNED_TO_AUTHENTICATED_USER" | "DELIVERABLE_UPLOAD_REFERENCE_FILE" | "DELIVERABLE_UPLOAD_REVIEW_ASSET_ASSIGNED_TO_ANOTHER_USER" | "DELIVERABLE_UPLOAD_REVIEW_ASSET_ASSIGNED_TO_AUTHENTICATED_USER" | "JOB_ADD_COMMENT" | "JOB_ASSIGN_RATING_TO_CLOSED" | "JOB_CLOSE_JOB" | "JOB_CREATE_WITHOUT_CONTRACT" | "JOB_EDIT_DETAILS" | "JOB_MANAGE_PAYMENT_REQUESTS" | "JOB_RESEND_CONTRACT" | "JOB_REVOKE_CONTRACT_IF_UNSIGNED_BY_FREELANCER" | "JOB_SIGN_AND_SEND_CONTRACT" | "JOB_TERMINATE_SIGNED_CONTRACT" | "JOB_UPLOAD_ASSOCIATED_FILES_OF_CONTRACT" | "ORGANIZATION_ADMIN_MANAGE_BILLING_INFO" | "ORGANIZATION_ADMIN_MANAGE_CONTRACTS_TEMPLATE" | "ORGANIZATION_ADMIN_MANAGE_CUSTOMIZATION" | "ORGANIZATION_ADMIN_MANAGE_ORGANIZATION_PROFILE" | "ORGANIZATION_ADMIN_MANAGE_STAFF_ROLE_AND_PERMISSIONS" | "ORGANIZATION_ADMIN_MANAGE_STORAGE" | "ORGANIZATION_ADMIN_RECEIVE_SYSTEM_NOTIFICATIONS" | "PRODUCT_CREATE" | "PRODUCT_DEACTIVATE" | "PRODUCT_DELETE" | "PRODUCT_EDIT_DETAILS" | "RELEASE_CREATE" | "RELEASE_DEACTIVATE" | "RELEASE_DELETE" | "RELEASE_EDIT_BUDGET" | "RELEASE_EDIT_DETAILS" | "RELEASE_VIEW_BUDGET" | "SOLICITATION_CREATE" | "SOLICITATION_DELETE_ASSIGNED_TO_AUTHENTICATED_USER" | "SOLICITATION_EDIT_DETAILS_ASSIGNED_TO_ANOTHER_USER" | "SOLICITATION_EDIT_DETAILS_ASSIGNED_TO_AUTHENTICATED_USER" | "SOLICITATION_MARK_CLOSED_ASSIGNED_TO_ANOTHER_USER" | "SOLICITATION_MARK_CLOSED_ASSIGNED_TO_AUTHENTICATED_USER" | "SOLICITATION_REASSIGN_TO_ANOTHER_STAFF_MEMBER" | "SOLICITATION_REPLY_TO_SOLICITATION_MESSAGE_ASSIGNED_TO_ANOTHER_USER" | "SOLICITATION_REPLY_TO_SOLICITATION_MESSAGE_ASSIGNED_TO_AUTHENTICATED_USER" | "SOLICITATION_REVERT_SOLICITATION_TO_ACTIVE_ASSIGNED_TO_ANOTHER_USER" | "SOLICITATION_REVERT_SOLICITATION_TO_ACTIVE_ASSIGNED_TO_AUTHENTICATED_USER" | "SOLICITATION_SEND_ASSIGNED_TO_ANOTHER_USER" | "SOLICITATION_SEND_ASSIGNED_TO_AUTHENTICATED_USER" | "%future added value";
export type UpdateOrganizationRoleInput = {|
  id: string,
  name?: ?string,
  extraPermissions?: ?$ReadOnlyArray<?OrganizationPermission>,
  clientMutationId?: ?string,
|};
export type UpdateRoleMutationVariables = {|
  input: UpdateOrganizationRoleInput
|};
export type UpdateRoleMutationResponse = {|
  +updateOrganizationRole: ?{|
    +updatedOrganizationRole: ?{|
      +id: string,
      +name: string,
      +extraPermissions: ?$ReadOnlyArray<?OrganizationPermission>,
    |}
  |}
|};
export type UpdateRoleMutation = {|
  variables: UpdateRoleMutationVariables,
  response: UpdateRoleMutationResponse,
|};
*/


/*
mutation UpdateRoleMutation(
  $input: UpdateOrganizationRoleInput!
) {
  updateOrganizationRole(input: $input) {
    updatedOrganizationRole {
      id
      name
      extraPermissions
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateOrganizationRoleInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateOrganizationRole",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateOrganizationRolePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updatedOrganizationRole",
        "storageKey": null,
        "args": null,
        "concreteType": "OrganizationRoleNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "extraPermissions",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateRoleMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateRoleMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateRoleMutation",
    "id": null,
    "text": "mutation UpdateRoleMutation(\n  $input: UpdateOrganizationRoleInput!\n) {\n  updateOrganizationRole(input: $input) {\n    updatedOrganizationRole {\n      id\n      name\n      extraPermissions\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7e85b5918514f783360416b8383f3560';
module.exports = node;
